module.exports = __webpack_public_path__ + "static/img/3-4-create-aftersale-resend.1aa0554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-4-create-aftersale-resend.png
// module id = 1325
// module chunks = 0